const module = { name: 'shared/movieTheaters/app', exports: {} }; const exports = module.exports;



import { fd_location as fd_location_updateLocation_getLocation } from 'require-global';

const { updateLocation, getLocation } = fd_location_updateLocation_getLocation;


import { default as locationFormCreation } from 'swug-fdRequire-call:fd-location/form/creation';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_util as util } from 'require-global';



import { default as tdpLocationHelper } from 'swug-fdRequire-call:theater/shared/tdpLocationHelper';



const Selectors = {
    LOCATION: '#theaters-near-me-location',
    MISSING_LOCATION_MSG: '#movie-theaters-search-header',
}
function onLocationChange() {
    const location = getLocation();
    util.navigate(window.location.origin + tdpLocationHelper.getShowtimesURL(location));
}
function run() {
    checkDependencies(module.name, debugLog);
    const location = getLocation();
    updateLocation(location);
    locationFormCreation.init({
        dropdown: {
            name: 'movieTheatersNearMe',
            relativeParent: Selectors.LOCATION,
        }
    });
    locationFormCreation.attach(onLocationChange);
    if (!Object.keys(location).length) {
        const missingLocationMsg = document.querySelector(Selectors.MISSING_LOCATION_MSG);
        missingLocationMsg.classList.remove('hide');
    }
}
run();
export default module.exports;